<!-- 入力フォームページアンカー -->
<a id="generateInputFormTop"></a>
<!-- 入力フォーム -->
<div class="generateInputForm" *ngIf="!confirmationFlag">
  <form [formGroup]="generateInputForm" autocomplete="off">
    <p-table *ngIf="['m301', 'm401'].includes(screenID)" [value]="memberInfos"
      styleClass="p-datatable-sm generate-input mb-1">
      <ng-template pTemplate="header">
        <tr class="desktop">
          <ng-container [ngSwitch]="screenID">
            <th scope="col" *ngSwitchCase="'m401'" colspan="2">団体情報</th>
            <th scope="col" *ngSwitchDefault colspan="2">団体情報</th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-memberInfo>
        <tr>
          <td class="label-center p-px-3">
            <label class="p-col-fixed p-d-flex p-p-0">
              <div class="p-col">{{memberInfo.label}}</div>
            </label>
          </td>
          <td class="input-form member-info">
            <div class="ui-fluid">
              <label>{{memberInfo.value}}</label>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- 入力情報出力領域 -->
    <p-table [value]="generateInputList" styleClass="p-datatable-sm generate-input">
      <!-- 入力情報タイトル -->
      <ng-template pTemplate="header">
        <tr class="desktop">
          <ng-container [ngSwitch]="screenID">
            <th *ngSwitchCase="'m401'" colspan="2">希望内容</th>
            <th *ngSwitchCase="'m301'" colspan="2">希望内容</th>
            <th *ngSwitchDefault colspan="2">入力</th>
          </ng-container>
        </tr>
      </ng-template>
      <!-- 入力情報出力箇所 -->
      <ng-template pTemplate="body" let-generateInputInformation>

        <!-- 画面表示不可以外の場合 -->
        <tr *ngIf="generateInputInformation.column_input_update != '4'">
          <!-- カラム名称 -->
          <td class="label-center p-px-3">
            <label class="p-col-fixed p-d-flex p-p-0">
              <div class="p-col " *ngIf="(generateInputInformation?.column_id == 'agenda_solution_end_date' 
                      || generateInputInformation?.column_id == 'agenda_solution_start_date'
                      || generateInputInformation?.column_id == 'agenda_need_start_date'
                      || generateInputInformation.column_id == 'agenda_need_end_date') && checkMobile
                ;else colNamePossiblePeriord">
                {{ generateInputInformation.column_name.split('（')[0]}}<br>
                <div class="col-name-line2 p-col-12 p-px-0">
                  {{ generateInputInformation.column_name.split('（')[1]}}
                </div>
              </div>
              <ng-template #colNamePossiblePeriord>
                <div class="p-col" *ngIf="generateInputInformation?.column_id == 'agenda_solution_possible_period' && checkMobile
                    ;else colNameOneLine">
                  実施不可能<br>時期・日時
                </div>
              </ng-template>
              <ng-template #colNameOneLine>
                <div class="p-col">
                  {{ generateInputInformation.column_name }}<br>
                  <div class="memo p-col-12 p-px-0" [innerHTML]="generateInputInformation.column_memo">
                  </div>
                </div>
              </ng-template>
              <!-- 項目定義マスタ.入力必須有無に'1'が存在する場合、必須を表示 -->
              <div *ngIf="generateInputInformation.column_input_require == '1'" class="p-tag p-tag-danger require">
                必須
              </div>
            </label>
          </td>

          <!-- 入力項目 -->
          <td class="input-form">
            <!-- 入力項目タイプを判定 -->
            <!-- テキスト -->
            <div class="ui-fluid"
              *ngIf="generateInputInformation.input_type == 'text' && !['agenda_need_oneword_message', 'agenda_solution_oneword_message'].includes(generateInputInformation.column_id)">
              <ng-container
                *ngIf="generateInputInformation.column_id == 'member_postal_no' || generateInputInformation.column_id == 'postal_no'; else notPostalInput">
                <input [title]="generateInputInformation.column_name || generateInputInformation.column_placeholder || '入力フィールド'" [name]="generateInputInformation.column_id" type="text"
                  [maxlength]="generateInputInformation.column_hsize" [class.errorItem]="
                  checkErrorItem(generateInputInformation.column_id)
                " [formControlName]="generateInputInformation.column_id" pInputText autocomplete="off" />
              </ng-container>
              <ng-template #notPostalInput>
                <input [title]="generateInputInformation.column_name || generateInputInformation.column_placeholder || '入力フィールド'" [name]="generateInputInformation.column_id" type="text"
                  [maxlength]="generateInputInformation.column_hsize" [class.errorItem]="
                  checkErrorItem(generateInputInformation.column_id)
                " [formControlName]="generateInputInformation.column_id" pInputText autocomplete="off"
                  [placeholder]="generateInputInformation.column_placeholder" />
              </ng-template>
            </div>
            <div class="ui-fluid"
              *ngIf="generateInputInformation.input_type == 'text' && ['agenda_need_oneword_message'].includes(generateInputInformation.column_id)">
              <textarea title="テキストエリア" [name]="generateInputInformation.column_id" [maxlength]="generateInputInformation.column_hsize"
                rows="2" id="agenda_need_oneword_message" [class.errorItem]="
                              checkErrorItem(generateInputInformation.column_id)
                            " [formControlName]="generateInputInformation.column_id" pInputTextarea autocomplete="off"
                placeholder="記入例：こどもたちにいろいろな体験を求めています！
　　　　　 お遊戯会の見学などから始めてみたいです！"></textarea>
            </div>
            <div class="ui-fluid"
              *ngIf="generateInputInformation.input_type == 'text' && ['agenda_solution_oneword_message'].includes(generateInputInformation.column_id)">
              <textarea title="テキストエリア" [name]="generateInputInformation.column_id" [maxlength]="generateInputInformation.column_hsize"
                rows="2" id="agenda_solution_oneword_message" [class.errorItem]="
                              checkErrorItem(generateInputInformation.column_id)
                            " [formControlName]="generateInputInformation.column_id" pInputTextarea autocomplete="off"
                [placeholder]="generateInputInformation.column_placeholder"></textarea>
            </div>

            <!-- ファイル -->
            <!-- file -->
            <div class="ui-fluid"
              *ngIf="generateInputInformation.input_type == 'file' || generateInputInformation.input_type == 'image'">
              <input title="ファイル情報格納用フィールド"  type="hidden" [name]="generateInputInformation.column_id"
                [formControlName]="generateInputInformation.column_id" pInputText autocomplete="off" />
              <p-fileUpload #fileUpload [customUpload]="true" (onSelect)="
                  uploadFile(
                    $event,
                    generateInputInformation.column_id,
                    fileUpload
                  )
                " [showUploadButton]="false" [showCancelButton]="false" [multiple]="false" class="btn-upload">
                <ng-template pTemplate="content">
                  <div class="file-content"
                    *ngIf="(generateInputInformation.column_id == 'agenda_solution_icon_image' || generateInputInformation.column_id == 'agenda_need_icon_image') && fileUploadedImage">
                    <div class="file_name">{{ fileUploadedImage.name }}</div>
                    <div>
                      <i class="pi pi-times"
                        (click)="removeFile(fileUploadedImage, fileUpload, generateInputInformation.column_id)"></i>
                    </div>
                  </div>
                  <div class="file-content"
                    *ngIf="(generateInputInformation.column_id == 'agenda_solution_document' || generateInputInformation.column_id == 'agenda_need_document') && fileUploadDocument">
                    <div class="file_name">{{ fileUploadDocument.name }}</div>

                    <div>
                      <i class="pi pi-times"
                        (click)="removeFile(fileUploadDocument, fileUpload, generateInputInformation.column_id)"></i>
                    </div>
                  </div>
                </ng-template>
              </p-fileUpload>
            </div>

            <!-- 日付 -->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'date'">
              <p-calendar [name]="generateInputInformation.column_id" [showIcon]="true" [showButtonBar]="true"
                [yearNavigator]="true" [monthNavigator]="true" [readonlyInput]="true" dateFormat="yy/mm/dd"
                dataType="string" appendTo="body" [readonlyInput]="true" yearRange="2000:2999" [inputStyleClass]="
                  checkErrorItem(generateInputInformation.column_id)
                    ? 'errorItem'
                    : ''
                " [formControlName]="generateInputInformation.column_id" translate>
              </p-calendar>
            </div>

            <!-- 数字 -->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'number'">
              <input title="id" [name]="generateInputInformation.column_id" type="number" [class.errorItem]="
                  checkErrorItem(generateInputInformation.column_id)
                " [formControlName]="generateInputInformation.column_id" pInputText autocomplete="off"
                [placeholder]="generateInputInformation.column_placeholder" />
            </div>

            <!-- チェックボックス -->
            <div class="ui-fluid p-d-flex p-grid desktop" *ngIf="generateInputInformation.input_type == 'checkbox'"
              [class.errorItemBorder]="
                checkErrorItem(generateInputInformation.column_id)
              ">
              <div *ngFor="
                  let code_list of generateInputInformation.column_code_list_multi
                ">
                <p-checkbox [name]="generateInputInformation.column_id" [label]="code_list.name"
                  [value]="code_list.value" [formControl]="
                    generateInputForm.controls[
                      generateInputInformation.column_id
                    ]
                  " class="p-col">
                </p-checkbox>
              </div>
            </div>

            <div class="ui-fluid mobile" *ngIf="generateInputInformation.input_type == 'checkbox'"
              [class.errorItemBorder]="
                checkErrorItem(generateInputInformation.column_id)
              ">
              <div *ngFor="
                  let code_list of generateInputInformation.column_code_list_multi
                ">
                <p-checkbox [name]="generateInputInformation.column_id" [label]="code_list.name"
                  [value]="code_list.value" [formControl]="
                    generateInputForm.controls[
                      generateInputInformation.column_id
                    ]
                  " class="p-col">
                </p-checkbox>
              </div>
            </div>

            <!-- ラジオボタン -->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'radio'" [class.errorItemBorder]="
                checkErrorItem(generateInputInformation.column_id)
              ">
              <ng-container *ngIf="generateInputInformation.column_id == 'member_class_id'">
                <div class="p-field-radiobutton" *ngFor="
                  let column of generateInputInformation.column_code_list_multi
                ">
                  <p-radioButton [name]="generateInputInformation.column_id" [label]="column.name"
                    [value]="column.value" [formControlName]="generateInputInformation.column_id"
                    (onClick)="onChangeClassId(column.value)">
                  </p-radioButton>
                </div>
              </ng-container>
              <ng-container *ngIf="generateInputInformation.column_id != 'member_class_id'">
                <div class="p-field-radiobutton" *ngFor="
                  let column of generateInputInformation.column_code_list_multi
                ">
                  <p-radioButton [name]="generateInputInformation.column_id" [label]="column.name"
                    [value]="column.value" [formControlName]="generateInputInformation.column_id">
                  </p-radioButton>
                </div>

              </ng-container>
            </div>

            <!-- シングルセレクト-->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'single_select'">
              <ng-container
                *ngIf="generateInputInformation.column_id == 'member_municipalities' || generateInputInformation.column_id == 'municipalities'; else notPrefectures">
                <p-dropdown
                  (onShow)="generateInputInformation.column_code_list_multi.length >= 10?resetScrollPullDown($event):null"
                  [name]="generateInputInformation.column_id" [options]="postalNoList" placeholder="　"
                  optionLabel="name" optionValue="value" [showClear]="false" [filter]="
                    generateInputInformation.column_code_list_multi.length >= 10
                  " emptyFilterMessage="検索結果が存在しません" [styleClass]="
                    checkErrorItem(generateInputInformation.column_id)
                      ? 'errorItem'
                      : ''
                  " [formControl]="
                    generateInputForm.controls[
                      generateInputInformation.column_id
                    ]
                  ">
                </p-dropdown>
              </ng-container>
              <ng-template #notPrefectures>
                <ng-container
                  *ngIf="generateInputInformation.column_id == 'agenda_category_class_cd1' || generateInputInformation.column_id == 'agenda_category_class_cd2'; else normalSingle">
                  <ng-container *ngIf="generateInputInformation.column_id == 'agenda_category_class_cd1'">
                    <p-dropdown
                      (onShow)="generateInputInformation.column_code_list_multi.length >= 10?resetScrollPullDown($event):null"
                      [options]="generateInputInformation.column_code_list_multi" placeholder="　"
                      optionLabel="class_name1" optionValue="value" [showClear]="true" [filter]="
                    generateInputInformation.column_code_list_multi.length >= 10
                  " emptyFilterMessage="検索結果が存在しません" [styleClass]="
                  checkErrorItem(generateInputInformation.column_id)
                    ? 'errorItem'
                    : ''
                " [formControl]="
                  generateInputForm.controls[
                    generateInputInformation.column_id
                  ]
                " appendTo="body" (onChange)="onChangCategory($event)"></p-dropdown>
                  </ng-container>
                  <ng-container *ngIf="generateInputInformation.column_id == 'agenda_category_class_cd2'">
                    <p-dropdown [name]="generateInputInformation.column_id" [options]="listSubCategory" placeholder="　"
                      optionLabel="name" optionValue="value" [showClear]="true" emptyFilterMessage="検索結果が存在しません"
                      appendTo="body" [styleClass]="
                    checkErrorItem(generateInputInformation.column_id)
                      ? 'errorItem'
                      : ''
                  " [formControl]="
                    generateInputForm.controls[generateInputInformation.column_id]
                  "></p-dropdown>


                  </ng-container>
                </ng-container>
                <ng-template #normalSingle>
                  <ng-container *ngIf="generateInputInformation.column_id == 'member_class_id'; else normalSingle2">
                    <p-dropdown
                      (onShow)="generateInputInformation.column_code_list_multi.length >= 10?resetScrollPullDown($event):null"
                      [name]="generateInputInformation.column_id"
                      [options]="generateInputInformation.column_code_list_multi" placeholder="　" optionLabel="name"
                      optionValue="value" [showClear]="true" [filter]="
                      generateInputInformation.column_code_list_multi.length >= 10
                    " emptyFilterMessage="検索結果が存在しません" (onChange)="onchangeClassId($event)" appendTo="body"
                      [styleClass]="
                      checkErrorItem(generateInputInformation.column_id)
                        ? 'errorItem'
                        : ''
                    " [formControl]="
                      generateInputForm.controls[
                        generateInputInformation.column_id
                      ]
                    ">
                    </p-dropdown>
                  </ng-container>
                  <ng-template #normalSingle2>
                    <ng-container
                      *ngIf="generateInputInformation.column_id == 'member_class_sub_id'; else normalSingle3">
                      <p-dropdown
                        (onShow)="generateInputInformation.column_code_list_multi.length >= 10?resetScrollPullDown($event):null"
                        [name]="generateInputInformation.column_id" [options]="organizationDetail" placeholder="　"
                        optionLabel="name" optionValue="value" [showClear]="true" [filter]="
                      generateInputInformation.column_code_list_multi.length >= 10
                    " emptyFilterMessage="検索結果が存在しません" appendTo="body" [styleClass]="
                      checkErrorItem(generateInputInformation.column_id)
                        ? 'errorItem'
                        : ''
                    " [formControl]="
                      generateInputForm.controls[
                        generateInputInformation.column_id
                      ]
                    ">
                      </p-dropdown>
                    </ng-container>
                    <ng-template #normalSingle3>
                      <ng-container
                        *ngIf="generateInputInformation.column_id == 'member_member_id'; else normalSingle4">
                        <p-dropdown
                          (onShow)="generateInputInformation.column_code_list_multi.length >= 10?resetScrollPullDown($event):null"
                          [name]="generateInputInformation.column_id"
                          [options]="generateInputInformation.column_code_list_multi" placeholder="　" optionLabel="name"
                          optionValue="value" [showClear]="true" [filter]="
                      generateInputInformation.column_code_list_multi.length >= 10
                    " emptyFilterMessage="検索結果が存在しません" [styleClass]="
                      checkErrorItem(generateInputInformation.column_id)
                        ? 'errorItem'
                        : ''
                    " [formControl]="
                      generateInputForm.controls[
                        generateInputInformation.column_id
                      ]
                    ">
                        </p-dropdown>
                      </ng-container>
                      <ng-template #normalSingle4>
                        <p-dropdown
                          (onShow)="generateInputInformation.column_code_list_multi.length >= 10?resetScrollPullDown($event):null"
                          [name]="generateInputInformation.column_id"
                          [options]="generateInputInformation.column_code_list_multi" placeholder="　" optionLabel="name"
                          optionValue="value" [showClear]="true" [filter]="
                      generateInputInformation.column_code_list_multi.length >= 10
                    " emptyFilterMessage="検索結果が存在しません" appendTo="body" [styleClass]="
                      checkErrorItem(generateInputInformation.column_id)
                        ? 'errorItem'
                        : ''
                    " [formControl]="
                      generateInputForm.controls[
                        generateInputInformation.column_id
                      ]
                    ">
                        </p-dropdown>
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </ng-template>
              </ng-template>
            </div>

            <!-- マルチセレクト -->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'multiple_select'">
              <p-multiSelect [name]="generateInputInformation.column_id"
                [options]="generateInputInformation.column_code_list_multi" defaultLabel="　"
                emptyFilterMessage="検索結果が存在しません" optionLabel="name" appendTo="body" [styleClass]="
                  checkErrorItem(generateInputInformation.column_id)
                    ? 'errorItem'
                    : ''
                " [formControl]="
                  generateInputForm.controls[generateInputInformation.column_id]
                ">
              </p-multiSelect>
            </div>

            <!-- テキストエリア -->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'textarea'">
              <textarea title="テキストエリア" [name]="generateInputInformation.column_id" [maxlength]="generateInputInformation.column_hsize"
                rows="10" [class.errorItem]="
                  checkErrorItem(generateInputInformation.column_id)
                " [formControlName]="generateInputInformation.column_id" pInputTextarea autocomplete="off"
                [placeholder]="generateInputInformation.column_placeholder"></textarea>
            </div>

            <!-- パスワード -->
            <div class="ui-fluid" *ngIf="generateInputInformation.input_type == 'password'">
              <input title="パスワード" [name]="generateInputInformation.column_id" type="password"
                [maxlength]="generateInputInformation.column_hsize" [class.errorItem]="
                  checkErrorItem(generateInputInformation.column_id)
                " [formControlName]="generateInputInformation.column_id" pInputText autocomplete="off" />
            </div>

            <!-- エラーメッセージ出力箇所 -->
            <app-validator-message [control]="
                generateInputForm.get(generateInputInformation.column_id)
              ">
            </app-validator-message>
          </td>
        </tr>

        <!-- ピッカーリスト -->
        <!-- TODO 条件仮置き-->
        <tr *ngIf="generateInputInformation.input_type == 'test'">
          <td colspan="2">
            <br />
            <p-pickList [source]="pickListSource(generateInputInformation.column_id)"
              [target]="pickListTarget(generateInputInformation.column_id)"
              [sourceHeader]="generateInputInformation.column_name" targetHeader="選択リスト" [dragdrop]="true"
              [showSourceControls]="false" [showTargetControls]="false" filterBy="name" (onMoveToTarget)="
                moveToTarget(generateInputInformation.column_id, $event)
              " (onMoveToSource)="
                moveToSource(generateInputInformation.column_id, $event)
              " (onMoveAllToTarget)="
                moveToTarget(generateInputInformation.column_id, $event)
              " (onMoveAllToSource)="
                moveToSource(generateInputInformation.column_id, $event)
              ">
              <ng-template let-code pTemplate="item">
                {{ code.name }}
              </ng-template>
            </p-pickList>
            <br />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </form>

  <!-- ボタンエリア -->
  <div class="buttonArea">
    <button class="button p-button-br-7" type="submit" label="入力内容を確認" (click)="inputVerification()"
      [disabled]="!generateInputForm.valid" pButton></button>
  </div>
</div>

<!-- 入力確認 -->
<div class="generateInputConfirmation" *ngIf="confirmationFlag">
  <p-table *ngIf="['m301', 'm401'].includes(screenID)" [value]="memberInfos"
    styleClass="p-datatable-sm generate-input mb-1">
    <ng-template pTemplate="header">
      <tr class="desktop">
        <ng-container [ngSwitch]="screenID">
            <th scope="col" *ngSwitchCase="'m401'" colspan="2">団体情報</th>
            <th scope="col" *ngSwitchDefault colspan="2">団体情報</th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-memberInfo>
      <tr>
        <td class="label-center p-px-3">
          <label class="p-col-fixed p-d-flex p-p-0">
            <div class="p-col">{{memberInfo.label}}</div>
          </label>
        </td>
        <td class="input-form member-info">
          <div class="ui-fluid">
            <label>{{memberInfo.value}}</label>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!-- 確認情報出力領域 -->
  <p-table [value]="generateInputFormConfirmationList" styleClass="p-datatable-sm">
    <!-- 確認情報タイトル -->
    <ng-template pTemplate="header">
      <tr *ngIf="!['m301', 'm401'].includes(screenID)">
        <th scope="col" colspan="2">確認</th>
      </tr>
      <tr *ngIf="['m301', 'm401'].includes(screenID)">
        <th scope="col" colspan="2">希望内容</th>
      </tr>
    </ng-template>
    <!-- 確認情報出力箇所 -->
    <ng-template pTemplate="body" let-generateInputFormConfirmation>
      <tr>
        <!-- カラム名称 -->
        <td class="label-center p-px-3">
          <label class="p-col-fixed p-p-0" *ngIf="(generateInputInformation?._columnName == '支援の掲載期間（掲載開始日）' 
                  || generateInputInformation?._columnName == '支援の掲載期間（掲載終了日）'
                  || generateInputInformation?._columnName == '依頼の掲載期間（掲載開始日）'
                  || generateInputInformation._columnName == '依頼の掲載期間（掲載終了日）') && checkMobile
            ;else colNamePossiblePeriord">
            {{ generateInputFormConfirmation._columnName.split('（')[0]}}<br>
            <div class="col-name-line2 p-col-12 p-px-0">
              ({{ generateInputFormConfirmation._columnName.split('（')[1]}}
            </div>
          </label>
          <ng-template #colNamePossiblePeriord>
            <label class="p-col-fixed p-p-0" *ngIf="generateInputFormConfirmation?._columnName == '実施不可能時期・日時' && checkMobile
                ;else colNameOneLine">
              実施不可能<br>時期・日時
            </label>
          </ng-template>
          <ng-template #colNameOneLine>
            <label class="p-col-fixed p-p-0">
              {{ generateInputFormConfirmation._columnName }}
            </label>
          </ng-template>
        </td>
        <!-- 入力項目値 -->
        <td class="ui-fluid confirmationData">
          {{ generateInputFormConfirmation._columnData }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- ボタンエリア -->
  <div class="buttonArea desktop">
    <button class="button p-button-br-7" type="button" label="登録" (click)="returnGenerateInputForm()"
      [disabled]="insertFlag" pButton></button>
    <button class="button p-button-br-7" type="button" label="戻る" (click)="returnConfirmationButton()"
      [disabled]="insertFlag" pButton></button>
  </div>

  <div class="buttonArea p-d-flex mobile p-jc-center">
    <button class="p-col-5 button p-button-br-7 p-mr-2" type="button" label="登録" (click)="returnGenerateInputForm()"
      [disabled]="insertFlag" pButton></button>
    <button class="p-col-5 button p-button-br-7" type="button" label="戻る" (click)="returnConfirmationButton()"
      [disabled]="insertFlag" pButton></button>
  </div>
</div>